<template>

  <div id="training" class="d-flex">
    <div class="layout-content container-fluid">
      <div class=" tab-filtros">
        <div class="content-loader" v-if="loading2">
          <div id="loader2"></div>
          <div class="cssload-dots">
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
          </div>
        </div>

        <div class="row">

          <div class="col-12 m-0 p-0">
            <button class="button-secundary" style="margin-left: auto;
margin-bottom: 10px;
margin-right: 15px;
position: realtive;
width: 121px;
height: 40px;
border-radius: 100px;" v-b-toggle.filtro variant="light">
              <span class="when-opened">
                Filtros
                <img class=" pl-0" src="@/assets/images/icons/filter.svg">
              </span>
              <span class="when-closed">
                Filtros
                <img class=" pl-0" src="@/assets/images/icons/filter.svg">
              </span>
            </button>
          </div>
        </div>
        <!--b-collapse id="filtro" class="col-12 mt-4 py-5 filter">
      <div class="row">
        <div class="col-md-9">
          <div class="col-md-9 col-sm-10 my-3">
            <h3>Busqueda:</h3>
            <input
              v-model="filter"
              @keydown="startTipyng()"
              @keyup="finishTipyng()"
              type="text"
              class="form-control my-3 input-vp2"
              placeholder="Búsqueda por nombre o punto de venta"
            />
          </div>
          <div class="col-md-11">
            <h3>Estado de novedad:</h3>
            <div class="d-flex flex-wrap">
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="approved"
                  name="approved"
                  value="approved"
                />
                <label for="approved">
                  <span class="status mt-4" style="background-color: #edf9f0">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/check.svg"
                      width="20px"
                    />Aprobado
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="rejected"
                  name="rejected"
                  value="rejected"
                />
                <label for="rejected">
                  <span class="status my-2" style="background-color: #feefef">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/deny-red.svg"
                      width="20px"
                    />Rechazado
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="pending"
                  name="pending"
                  value="pending"
                />
                <label for="pending">
                  <span class="status" style="background-color: #fff4ec">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/orange-clock.svg"
                      width="20px"
                    />Pendiente
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="cancelled"
                  name="cancelled"
                  value="cancelled"
                />
                <label for="cancelled">
                  <span class="status" style="background-color: #f5f5f5">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/close_gray.svg"
                      width="20px"
                    />Cancelado
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="training"
                  name="training"
                  value="training"
                />
                <label for="training">
                  <span class="status" style="background-color: #feffc8">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/weight.svg"
                      width="20px"
                    />Entrenando
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="ending"
                  name="ending"
                  value="ending"
                />
                <label for="ending">
                  <span class="status" style="background-color: #f7e7ff">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/timelapse.svg"
                      width="20px"
                    />Finalizando
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <b-button
            pill
            class="text-center mb-4 mt-4"
            size="lg"
            variant="success"
            @click="loadRows()"
          >
            Aplicar filtro
          </b-button>
          <br />
          <b-button
            pill
            class="text-center"
            size="lg"
            variant="outline-danger"
            style="border: none"
            @click="limpiar()"
          >
            Limpiar filtro <span class="icon icon-bin"></span>
          </b-button>
        </div>
      </div>
    </b-collapse-->

        <div class="row">
          <div class="col-md-12">
            <b-collapse id="filtro" class="filtros ">


              <div class="row">
                <div class="col-md-5 ml-8 " style="margin-left: 16px;">

                  <span class="cta" style="color: #5D5FEF;">Estado de novedad</span>
                  <div class="linea">
                  </div>



                  <div class="d-flex flex-wrap">
                    <div class="m-3">
                      <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="approved"
                        name="approved" value="approved">
                      <label for="approved">
                        <span class="status mt-4" style="background-color:#EDF9F0">
                          <img class="centerImg1 mr-3" src="@/assets/images/icons/check.svg" width="20px">Aprobado
                        </span>
                      </label>
                    </div>
                    <div class="m-3">
                      <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="rejected"
                        name="rejected" value="rejected">
                      <label for="rejected">
                        <span class="status my-2" style="background-color:#FEEFEF">
                          <img class="centerImg1 mr-3" src="@/assets/images/icons/deny-red.svg" width="20px">Rechazado
                        </span>
                      </label>
                    </div>
                    <div class="m-3">
                      <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="pending"
                        name="pending" value="pending">
                      <label for="pending">
                        <span class="status" style="background-color:#FFF4EC">
                          <img class="centerImg1 mr-3" src="@/assets/images/icons/orange-clock.svg"
                            width="20px">Pendiente
                        </span>
                      </label>
                    </div>
                    <div class="m-3">
                      <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="cancelled"
                        name="cancelled" value="cancelled">
                      <label for="cancelled">
                        <span class="status" style="background-color:#F5F5F5">
                          <img class="centerImg1 mr-3" src="@/assets/images/icons/close_gray.svg" width="20px">Cancelado
                        </span>
                      </label>
                    </div>
                    <div class="mt-3 ml-3 mr-3">
                      <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="training2"
                        name="training2" value="training">
                      <label for="training2">
                        <span class="status" style="background-color:#FEFFC8">
                          <img class="centerImg1 mr-3" src="@/assets/images/icons/weight.svg" width="20px">Entrenando
                        </span>
                      </label>
                    </div>
                    <div class="mt-3 ml-0">
                      <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="ending" name="ending"
                        value="ending">
                      <label for="ending">
                        <span class="status" style="background-color:#F7E7FF">
                          <img class="centerImg1 mr-3" src="@/assets/images/icons/timelapse.svg"
                            width="20px">Finalizando
                        </span>
                      </label>
                    </div>

                  </div>


                  <!--div class="m-3">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="rejected" name="rejected" value="rejected">
                                <label for="rejected"> 
                                    <span class="status my-2" style="background-color:#FEEFEF">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/deny-red.svg" width="20px">Rechazado
                                    </span>    
                                </label>
                            </div>
                            <div class="m-3">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="pending" name="pending" value="pending">
                                <label for="pending"> 
                                    <span class="status" style="background-color:#FFF4EC">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/orange-clock.svg" width="20px">Pendiente
                                    </span>   
                                </label>
                            </div>
                            <div class="m-3">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="cancelled" name="cancelled" value="cancelled">
                                <label for="cancelled"> 
                                    <span class="status" style="background-color:#F5F5F5">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/close_gray.svg" width="20px">Cancelado
                                    </span> 
                                </label>
                            </div>
                            <div class="m-3">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="training" name="training" value="training">
                                <label for="training"> 
                                    <span class="status" style="background-color:#FEFFC8">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/weight.svg" width="20px">Entrenando
                                    </span> 
                                </label>
                            </div>
                            <div class="m-3">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="ending" name="ending" value="ending">
                                <label for="ending"> 
                                    <span class="status" style="background-color:#F7E7FF">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/timelapse.svg" width="20px">Finalizando
                                    </span>
                                </label>
                            </div-->



                </div>



                <div class="col-md-4 ml-8">

                  <span class="cta" style="color: #5D5FEF;">Punto de venta</span>
                  <div class="linea">

                  </div>
                  <div class="col-md-5">


                    <div class="buscar-empleado mt-4 mb-4">
                      <div class=" input-group-prepend">
                        <span class="icon ">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8.1665 0.666656C12.3065 0.666656 15.6665 4.02666 15.6665 8.16666C15.6665 12.3067 12.3065 15.6667 8.1665 15.6667C4.0265 15.6667 0.666504 12.3067 0.666504 8.16666C0.666504 4.02666 4.0265 0.666656 8.1665 0.666656ZM8.1665 14C11.389 14 13.9998 11.3892 13.9998 8.16666C13.9998 4.94332 11.389 2.33332 8.1665 2.33332C4.94317 2.33332 2.33317 4.94332 2.33317 8.16666C2.33317 11.3892 4.94317 14 8.1665 14ZM15.2373 14.0592L17.0051 15.8263C17.3308 16.1519 17.3309 16.6798 17.0053 17.0054C16.6797 17.331 16.1517 17.331 15.8262 17.0053L14.059 15.2375L15.2373 14.0592Z"
                              fill="#546E7A" />
                          </svg>
                        </span>
                      </div>
                      <input type="search" placeholder="Buscar punto de venta" aria-label="Buscar punto de venta"
                        autocomplete="off" class="form-control body_regular " :clearable="false" style="border:0px"
                        v-model="filter" @keydown="startTipyng()" @keyup="finishTipyng()">
                    </div>




                  </div>
                </div>


              </div>






              <!--div class="col-xl-6 col-sm-10 my-3">
                        <h3>Busqueda:</h3>
                        <input v-model="filter" @keydown="startTipyng()" @keyup="finishTipyng()" type="text" class="form-control my-3 input-vp2" placeholder="Busqueda por Nombre o punto de venta">
                    </div>
                    <div class="col-xl-8 col-sm-10">
                        <h3>Estado de novedad:</h3>
                        <div class="d-flex flex-wrap">
                            <div class="m-2">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="approved" name="approved" value="approved">
                                <label for="approved"> 
                                    <span class="status mt-4" style="background-color:#EDF9F0">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/check.svg" width="20px">Aprobado
                                    </span>    
                                </label>
                            </div>
                            <div class="m-2">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="rejected" name="rejected" value="rejected">
                                <label for="rejected"> 
                                    <span class="status my-2" style="background-color:#FEEFEF">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/deny-red.svg" width="20px">Rechazado
                                    </span>    
                                </label>
                            </div>
                            <div class="m-2">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="pending" name="pending" value="pending">
                                <label for="pending"> 
                                    <span class="status" style="background-color:#FFF4EC">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/orange-clock.svg" width="20px">Pendiente
                                    </span>   
                                </label>
                            </div>
                            <div class="m-2">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="cancelled" name="cancelled" value="cancelled">
                                <label for="cancelled"> 
                                    <span class="status" style="background-color:#F5F5F5">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/close_gray.svg" width="20px">Cancelado
                                    </span> 
                                </label>
                            </div>
                            <div class="m-2">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="training" name="training" value="training">
                                <label for="training"> 
                                    <span class="status" style="background-color:#FEFFC8">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/weight.svg" width="20px">Entrenando
                                    </span> 
                                </label>
                            </div>
                            <div class="m-2">
                                <input v-model="filterSelected" type="checkbox" v-on:change="loadRows()" id="ending" name="ending" value="ending">
                                <label for="ending"> 
                                    <span class="status" style="background-color:#F7E7FF">
                                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/timelapse.svg" width="20px">Finalizando
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div-->
            </b-collapse>

          </div>
        </div>

        <!--div v-if="loading" class="col-12"-->
        <div class="row">
          <div class="col-md-12">
            <div class="ml-0 mt-2 mb-1 mr-0">
              <div class="mt-2" v-if="loading" id="loader"></div>

              <div v-else class="px-0  ">
                <datatable :columns="datatable.columns" :data="datatable.rows" :per-page="datatable.perPage"
                  :page="datatable.page" class="table table-hover table-borderless ">
                  <template slot-scope="{ row, columns }">
                    <tr @click="editTraining(row.id)">
                      <template>
                        <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row">
                        </datatable-cell>
                      </template>
                    </tr>
                  </template>
                </datatable>
                <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
                  <Pagination :data="trainingInfo" :limit="10" @pagination-change-page="loadRows"></Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal de Edición/Infomativo de la novedad -->

        <b-modal v-if="training.data !== undefined" id="modal-training" hide-footer centered size="lg">

          <div class="modal-training">
            <div v-if="loading2" class="col-12">
              <!-- div class="mt-5" v-if="loading2" id="loader2"></div-->

            </div>
            <div v-else>
              <div class="px-3 table-responsive table-views">
                <datatable :columns="datatableInfoTraining.columns" :data="datatableInfoTraining.rows" class="col-12">
                  <template slot-scope="{ row, columns }">
                    <tr>
                      <template>
                        <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row">
                        </datatable-cell>
                      </template>
                    </tr>
                  </template>
                </datatable>
              </div>
              <div class="
              row
              my-5
              px-3
              col-12
              d-flex
              formulario
              justify-content-between
            ">
                <div class="col-sm-12 col-md-6 pl-5">
                  <h3 class="text-left">Tipo de entrenamiento</h3>
                  <b-form-group class="mt-3">
                    <b-form-radio :disabled="notEdit" class="mb-2" v-model="promotion" name="promotion" value="false">
                      Entrenamiento por primera vez</b-form-radio>
                    <b-form-radio :disabled="notEdit" v-model="promotion" name="promotion" value="true">Entrenamiento
                      por promoción</b-form-radio>
                  </b-form-group>
                  <div class="charge col-12 mt-5 p-3" v-if="promotion != null">
                    <h3 class="text-left">
                      ¿Qué cargo se le asignará al empleado?
                    </h3>
                    <p>
                      <img class="centerImg1 mr-2" src="@/assets/images/icons/check.svg" width="18px" />Si
                      <span class="text-success font-weight-bold">aprueba</span> su
                      entrenamiento
                    </p>
                    <b-form-select :disabled="notEdit" class="mt-3" v-model="newCharge" :options="charges">
                    </b-form-select>
                    <div v-if="promotion == 'false'" class="alert alert-info alert-sm alert-info-custom mt-4"
                      role="alert">
                      <h5>
                        <span class="icon icon-info text-primary mr-2"></span>
                        Recuerda que si el empleado no aprueba su período de
                        entrenamiento, quedará bloqueado de la plataforma.
                      </h5>
                    </div>
                  </div>
                </div>
                <div v-if="training" class="col-sm-12 col-md-6">
                  <h3 class="mb-5">Período de entrenamiento establecido</h3>
                  <vc-date-picker v-if="training.data.status == 'pending'" class="p-5" :model-config="modelConfig"
                    show-caps is-expanded v-model="range" color="teal" is-range />
                  <vc-calendar :from-date="new Date(date)" class="p-5" is-expanded
                    v-if="training.data.status !== 'pending'" :attributes="attrs" />
                </div>
              </div>
              <div v-if="buttonEdit">
                <div class="col-12 px-5 my-5 d-flex justify-content-around">
                  <button :disabled="
                    promotion == null || newCharge.id == null || range.end == ''
                  " class="col-4 button-primary " @click="$bvModal.show('modal-confirm')">
                    <span> {{ buttonAccept }}</span>
                  </button>
                  <button class="col-4 button-danger mt-0" @click="$bvModal.show('modal-reject')">
                    <span> {{ buttonReject
                    }}</span><img src="@/assets/images/icons/delete_trash.svg" alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL CONFIRMACIÓN DE ENTRENAMIENTO  -->

        <b-modal v-if="training.data !== undefined" id="modal-confirm" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/warning.svg" width="15%" />
            <div class="text-center" v-if="buttonAccept == 'Confirmar entrenamiento'">
              <h3 class="mb-5 pt-5 font-weight-bold">
                ¿Estás seguro de asignarle entrenamiento a {{ employee.name }}??
              </h3>
              <p style="font-size: 16px">
                <span class="font-weight-bold">Desde: </span>{{ range.start }} al
                {{ range.end }}
              </p>
              <p style="font-size: 16px">
                <span class="font-weight-bold">Tipo de entrenamiento: </span>{{ promotion == "true" ? "Ascenso" :
                    "Primera vez"
                }}
              </p>
              <p style="font-size: 16px">
                <span class="font-weight-bold">Sí aprueba: </span>Se le asignará el
                cargo de {{ newCharge.name }}
              </p>
            </div>
            <div v-if="buttonAccept !== 'Confirmar entrenamiento'">
              <h3 class="mb-5 pt-5">
                ¿Estás seguro de <span class="font-weight-bold">aprobar </span> el
                entrenamiento de {{ employee.name }}?
              </h3>
            </div>
            <button class="button-primary mt-3 col-lg-6 col-sm-6 p-2" @click="nextStep(nextStatus)">
              <span>Sí, estoy seguro</span>
            </button>
            <button class="button-secundary mt-3 col-lg-6 col-sm-6" @click="$bvModal.hide('modal-confirm')">
              <span>Seguir Editando</span>
            </button>
          </div>
        </b-modal>

        <!--  MODAL DE CANCELACIÓ O RECHAZO DEL ENTRENAMIENTO  -->

        <b-modal v-if="training.data !== undefined" id="modal-reject" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/warning.svg" width="15%" />
            <h3 class="mb-5 pt-5">
              ¿Estás seguro de
              <span class="font-weight-bold">
                {{ training.data.status == "pending" ? "rechazar" : "reprobar" }}
              </span>
              el entrenamiento de {{ employee.name }}?
            </h3>
            <button class="button-primary mt-3 col-lg-6 col-sm-6 p-2" @click="nextStep(cancelStatus)">
              <span>Sí, estoy seguro</span>
            </button>
            <button class="button-secundary mt-3 col-lg-6 col-sm-6" @click="$bvModal.hide('modal-reject')">
              <span>Seguir Editando</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL CREACIÓN LINEA DE NEGOCIO -- EXITOSO  -->

        <b-modal id="modal-success" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/check_circle_green.svg" width="20%" />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>
            <button class="mt-5 mb-5 col-6 button-secundary  " @click="$bvModal.hide('modal-success')">
              <span>Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL FALLO DE OPERACIÓN -- FALLIDO -->

        <b-modal v-if="error.message" id="modal-fail" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%" />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ error.message }}</p>
            <button class="mb-5 col-6 button-danger " @click="$bvModal.hide('modal-fail')">
              <span>Entendido</span>
            </button>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";
import serverConfig from "@/services/config";
//import  "@/assets/css/general.css";

export default {
  name: "training",
  components: {
    Pagination,
  },
  data() {
    return {
      runtime: "",
      filter: "",
      filterSelected: [],
      serverPath: serverConfig.permisosURL,
      datatable: {
        total: 18,
        perPage: 20,
        columns: [],
        rows: [],
      },
      datatableInfoTraining: {
        columns: [],
        rows: [],
      },
      range: {
        start: "",
        end: "",
      },
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD", // Uses 'iso' if missing
      },
      promotion: null,
      newCharge: { id: null, name: "" },
      charges: [{ value: { id: null, name: "" }, text: "Elige un Cargo" }],
      cancelStatus: "",
      nextStatus: "",
      employee: {},
      buttonAccept: "",
      buttonReject: "",
      notEdit: false,
      attrs: {},
      buttonEdit: true,
      date: "",
    };
  },
  beforeMount() {
    this.loadRows();
  },
  computed: {
    ...mapState("modPayRollNews", [
      "trainingInfo",
      "training",
      "loading",
      "loading2",
      "error",
      "message",
    ]),
  },
  methods: {
    ...mapActions("modPayRollNews", [
      "actGetTrainingInfo",
      "actGetTrainingInfoById",
      "actSaveTrainingInfo",
    ]),
    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.loadRows()
      }, 1500);
    },
    limpiar() {
      // Estados
      document.getElementById('approved').checked = false;
      document.getElementById('rejected').checked = false;
      document.getElementById('pending').checked = false;
      document.getElementById('cancelled').checked = false;
      document.getElementById('training').checked = false;
      document.getElementById('ending').checked = false;

      this.filter = null;
      this.loadRows();
    },
    loadRows(page = 1) {
      let data2 = [];
      data2 = {
        page: page,
        filter: this.filter,
        status: this.filterSelected,
      };
      console.log(this.filterSelected);
      this.actGetTrainingInfo(data2).then(() => {
        this.datatable.columns = [
          {
            label: "Nombre y apellidos",
            field: "name_employee",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Linea de negocio",
            field: "category_name",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Punto de Venta",
            field: "point_sale",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Fecha de registro",
            field: "fecha",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Estado de novedad",
            field: "status",
            align: "left",
            headerClass: "theading",
            representedAs: ({ status }) =>
              `<span class="status" style="background-color:${status.color
              }"><img class="centerImg1 mr-3"  src="${require("@/assets/images/icons/" +
                status.icon)}" width="20px">${status.text}</span>`,
            interpolate: true,
          },
        ];
        this.datatable.rows = [];
        this.trainingInfo.data.forEach((x) => {
          let status = {};
          switch (x.status) {
            case "Pendiente":
              status = {
                color: "#FFF4EC",
                icon: "orange-clock.svg",
                text: x.status,
              };
              break;
            case "Entrenando":
              status = {
                color: "#FEFFC8",
                icon: "weight.svg",
                text: x.status,
              };
              break;
            case "Finalizando":
              status = {
                color: "#F7E7FF",
                icon: "timelapse.svg",
                text: x.status,
              };
              break;
            case "Rechazado":
              status = {
                color: "#FEEFEF",
                icon: "deny-red.svg",
                text: x.status,
              };
              break;
            case "Aprobado":
              status = {
                color: "#EDF9F0",
                icon: "check.svg",
                text: x.status,
              };
              break;
            case "Cancelado":
              status = {
                color: "#F5F5F5",
                icon: "close_gray.svg",
                text: x.status,
              };
              break;
          }
          this.datatable.rows.push({
            id: x.id,
            name_employee: x.name_employee,
            category_name: x.category_name,
            point_sale: x.point_sale,
            fecha: x.fecha,
            status: status,
          });
        });
      });
    },

    resetValues() {
      this.range = { start: "", end: "" };
      this.promotion = null;
      this.newCharge = { id: null, name: "" };
      this.datatableInfoTraining.rows = [];
      this.notEdit = false;
      this.buttonEdit = true;
    },
    editTraining(id) {
      this.resetValues();
      //this.$root.$emit("bv::show::modal", "modal-training");
      this.actGetTrainingInfoById(id).then(() => {
        this.$root.$emit("bv::show::modal", "modal-training");
        this.datatableInfoTraining.columns = [
          {
            label: "Nombre y apellidos",
            field: "name",
            align: "left",
            headerClass: "theading",
          },
          {
            label: this.training.employee.document,
            field: "cc",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Categoria",
            field: "category",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Punto de Venta",
            field: "point_sale",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Cargo asignado",
            field: "charge",
            align: "left",
            headerClass: "theading",
          },
        ];
        this.employee = this.training.employee;
        this.datatableInfoTraining.rows = [];
        this.datatableInfoTraining.rows.push({
          name: this.employee.name,
          cc: this.employee.cc,
          category: this.employee.category,
          point_sale: this.employee.point_sale,
          charge: this.employee.charge,
        });
        this.charges = [
          { value: { id: null, name: "" }, text: "Elige un Cargo" },
        ];
        this.training.charges.forEach((x) => {
          let chargesGroups = [];
          x.charges.forEach((y) => {
            chargesGroups.push({
              value: { id: y.id, name: y.name },
              text: y.name,
            });
          });
          this.charges.push({
            label: x.name_category,
            options: chargesGroups,
          });
        });
        if (this.training.data.status == "pending") {
          this.buttonAccept = "Confirmar entrenamiento";
          this.buttonReject = "Cancelar entrenamiento";
          this.nextStatus = "training";
          this.cancelStatus = "cancelled";
        } else {
          // Se establecen las fechas y atributos en el calendario

          let end = new Date(this.training.data.end_date);
          let endDay = end.getDate();
          end.setDate(endDay + 1);

          let start = new Date(this.training.data.start_date);
          let startDay = start.getDate();
          start.setDate(startDay + 1);

          this.date = start;

          this.attrs = [
            {
              highlight: {
                start: {
                  color: "teal",
                  fillMode: "solid",
                },
                base: {
                  color: "teal",
                  fillMode: "light",
                },
                end: {
                  color: "teal",
                  fillMode: "solid",
                },
              },
              dates: { start: start, end: end },
            },
            {
              key: "today",
              dot: "teal",
              dates: new Date(),
            },
          ];

          if (this.training.data.promotion !== null) {
            this.promotion =
              this.training.data.promotion == true ? "true" : "false";
          }
          this.range = { start: start, end: end };
          for (var i = 1; i < this.charges.length; i++) {
            this.charges[i].options.forEach((y) => {
              if (y.value.id == this.training.data.new_position_id) {
                this.newCharge = y.value;
              }
            });
          }
          this.notEdit = true;
          this.buttonAccept = "Aprobar entrenamiento";
          this.buttonReject = "Reprobar entrenamiento";
          this.nextStatus = "approved";
          this.cancelStatus = "rejected";

          if (
            this.training.data.status == "cancelled" ||
            this.training.data.status == "approved" ||
            this.training.data.status == "rejected"
          ) {
            this.buttonEdit = false;
          }
        }
      });
    },
    nextStep(x) {
      let data = {};
      if (x == "training") {
        data = {
          id: this.training.data.id,
          start_date: this.range.start,
          end_date: this.range.end,
          promotion: this.promotion == "true" ? true : false,
          new_position_id: this.newCharge.id,
          status: x,
        };
        this.actSaveTrainingInfo(data).then(() => {
          if (this.error.message) {
            this.$root.$emit("bv::hide::modal", "modal-confirm");
            this.$root.$emit("bv::hide::modal", "modal-training");
            this.$root.$emit("bv::show::modal", "modal-fail");
            this.loadRows();
            this.resetValues();
          } else {
            this.$root.$emit("bv::hide::modal", "modal-confirm");
            this.$root.$emit("bv::hide::modal", "modal-training");
            this.$root.$emit("bv::show::modal", "modal-success");
            this.loadRows();
            this.resetValues();
          }
        });
      } else {
        data = {
          id: this.training.data.id,
          status: x,
        };
        this.actSaveTrainingInfo(data).then(() => {
          if (this.error.message) {
            this.$root.$emit("bv::hide::modal", "modal-confirm");
            this.$root.$emit("bv::hide::modal", "modal-training");
            this.$root.$emit("bv::show::modal", "modal-fail");
            this.$root.$emit("bv::hide::modal", "modal-reject");

            this.loadRows();
            this.resetValues();
          } else {
            console.log('eeerror false');
            this.$root.$emit("bv::hide::modal", "modal-confirm");
            this.$root.$emit("bv::hide::modal", "modal-training");
            this.$root.$emit("bv::show::modal", "modal-success");
            this.$root.$emit("bv::hide::modal", "modal-reject");
            this.loadRows();
            this.resetValues();
          }
        });
      }
    },
  },
};
</script>


<style lang="scss"  >
#training {
  .filter {
    border: solid rgb(207, 207, 207) 1px;
    border-radius: 10px;
    background-image: url("../../assets/images/icons/vector-seacrh-filter.svg");
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 20%;

    h3 {
      font-weight: 600;
      color: #1C6776;
    }
  }

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  input[type="checkbox"]+label {
    margin-left: 5px !important;
  }

  .filtros-open {

    width: 1002px;

  }

  .filtros {

    display: flex;
    width: 100%;
    height: 216px;

    margin-bottom: 24px;

    flex-direction: column;

    /* content/00 */

    background: #FFFFFF;
    /* Bottom */
    //background-image: url("../../assets/images/icons/vector-seacrh-filter.svg");
    background-image: url("../../assets/images/onboarding/add_information.svg");
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 20%;

    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14);
    border-radius: 12px;
  }

  .linea {
    padding: 5px 5px;
    margin-top: 10px;
    border-top: 1px solid #CFD8DC;
    -o-border-image: linear-gradient(to right, rgba(66, 87, 119, 0) 5%, #CFD8DC 5%, #CFD8DC 95%, rgba(66, 87, 119, 0) 95%);
    border-image: linear-gradient(to right, rgba(66, 87, 119, 0) 5%, #CFD8DC 5%, #CFD8DC 95%, rgba(66, 87, 119, 0) 95%);
    border-image-slice: 1;
  }

  .input-vp2 {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;

  }

  .custom-checkbox {
    margin: 15px 0;
  }

  .buttonColapse {
    background: rgba(38, 152, 135, 0.14);
    border: 2px solid #269887;
    color: #269887;
    font-size: 12px;
    border-radius: 100px;
  }

  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }

  .status {
    padding: 5px 15px;
    border-radius: 20px;
  }

  .table-views {
    border-radius: 8px;
    width: 100%;
    padding: 0;
    margin: 10px 5px;

    .t-head {
      background-color: #F5F5F5;
      padding: 5px 15px;
      text-align: left;
    }

    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }

    thead tr {
      background-color: #EEF2FA;
      border-radius: 10px;
      text-align: left;
    }

    .theading {
      padding: 15px 15px;
    }

    tbody tr {
      border-radius: 10px;
    }

    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }

    tbody tr:hover {
      background-color: #F5F5F5;
    }
  }


  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: static;
    width: 358px;
    height: 44px;
    left: calc(50% - 428px/2);
    top: calc(50% - 44px/2);

    background: #FFFFFF;
    /* content/03 */

    border: 1px solid #B0BEC5;
    border-radius: 8px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 0px;
  }

  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;

  }


}

.modal-content {
  height: auto !important;
  left: 0px !important;
  background: #FFFFFF;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14) !important;
  border-radius: 16px !important;
}

.modal-content #modal-confirm {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  left: 0;

  position: absolute;
  width: 805px !important;
  height: 842px !important;
  left: 0px !important;
  top: 60px;

  /* content/00 */
  left: 0;
  background: #FFFFFF;
  /* Mid */

  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
  border-radius: 16px;

  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }

  .charge {
    border: 1px dashed #DDDDDD;
    border-radius: 8px;
  }

  .modal-header {
    border: none;
  }

  .input-vp2,
  button {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;

  }

  .btn-outline-success {
    border-radius: 20px;
    color: #269887;
    border-color: #269887;
  }

  .btn-outline-success:hover,
  .btn-success {
    color: white;
    background-color: #269887;
    border-color: #269887;
  }

  .btn-success:hover {
    background-color: #27a391;
  }

  .regular {
    background-color: white;
    border: none;
    color: #269887;
  }

  .delete {
    background-color: white;
    border: none;
    color: #DA1414;
  }

  h3 {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 30px;
    text-align: center;
  }

  /*#loader2 {
            margin: 20px auto;
            z-index: 1;
            width: 100px;
            height: 100px;
            border: 15px solid #f3f3f3;
            border-radius: 50%;
            border-top: 15px solid #8f8f8f;
            -webkit-animation: spin 2s linear infinite;
            animation: spin 2s linear infinite;
        }*/
  .table-views {
    height: fit-content;
    border-radius: 8px;
    padding: 0;

    .t-head {
      background-color: #F5F5F5;
      padding: 5px 15px;
      text-align: left;
      font-size: 15px;
    }

    thead tr {
      background-color: #EEF2FA;
      border-radius: 10px;
      text-align: left !important;
    }

    .theading {
      padding: 15px 10px;
    }

    th.theading span {
      font-size: 15px;
    }

    tbody tr {
      border-radius: 10px;
      border-bottom: 1px solid #E9ECEE;
    }

    tbody tr td {
      padding: 15px 10px;
      font-size: 14px;
    }

    .buttonColapse,
    .buttonColapse:hover,
    .buttonColapse:active {
      background-color: transparent;
      border: none;
      box-shadow: none;
    }
  }

  .formulario {
    h3 {
      font-size: 16px;
      color: #1C3A4E;
      font-weight: 600;
    }

    .vc-container {
      font-family: Poppins;
      box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
      border: none;

      .vc-grid-cell {
        margin: 5px;
      }
    }
  }
}
</style>
<style lang="scss"  scoped>
.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
  border: solid 5px;
  border-color: #007bff;
  background-color: #FFFFFF !important;
  ;
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: #FFFFFF;
}

.custom-control-label::before {
  border: solid 1px;
  border-color: #007bff !important;

}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
  width: 0px;
  height: 0px;

}

.button-confirmar {
  width: 258px !important;
}

/* clears the 'X' from Internet Explorer */
input[type=search]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

input[type=search]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the 'X' from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}



input[type="checkbox"] {
  display: none;


}

input[type="checkbox"]+label {

  margin-left: 25px;

}

input[ type=checkbox]+label:before {
  content: "";
  display: inline-block;


  width: 20px;
  height: 20px;


  border: 1px solid #7A7CFF;
  box-sizing: border-box;
  border-radius: 2px;
  text-align: center;
  vertical-align: text-top;
  line-height: 15px;
  margin: 3px 12px -3px 1px;
  padding: 0px;
  position: realtive;
  left: 28px;

}


input[ type=checkbox]:checked+label:before {
  content: "\02713";
  //font-size:10px;
  background: #5D5FEF;
  border-radius: 2px;
  color: #fff;

}

input[ type=checkbox]:focus+label:before {
  box-shadow: 0px 0px 3px 1px #ccc;
}

input[ type=checkbox]:hover+label:before {
  box-shadow: 0px 0px 4px #5D5FEF;
}
</style>
